import React from "react";

function Particle(props) {
  return <div />;
}

export default Particle;
